import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CashPaymentDelete from './CashPaymentDelete';
import EditCashPayments from '../EditCashPayments';
import CashPaymentDetailPopup from './CashPaymentDetailPopup';

const CashPaymentActionButton = ({ id, handleDelete, fetchPayments }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const params = useParams();
  const businessId = params?.business_id;

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleEditModal = () => {
    setShowEdit(!showEdit);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  return (
    <>
      <span>
        <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#cashPaymentDetail"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          icon={faEdit}
          size="1x"
          onClick={toggleEditModal}
          data-toggle="modal"
          data-target="#editCashPayment"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteCashPayment"
        />
      </span>

      {showDelete && (
        <CashPaymentDelete
          cash_paymentId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showEdit && (
        <EditCashPayments
          cash_paymentId={id}
          businessId={businessId}
          toggleEditModal={toggleEditModal}
          fetchPayments={fetchPayments}
          showEdit={showEdit}
        />
      )}

      {showView && (
        <CashPaymentDetailPopup
          cash_paymentId={id}
          toggleShowModal={toggleShowModal}
          showView={showView}
        />
      )}
    </>
  );
};

export default CashPaymentActionButton;
